import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ service, index = 0, onClick }) {
  const Icon = service.icon;
  return (
    <motion.button
      type="button"
      onClick={onClick}
      data-testid={`service-card-${service.slug}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      className="text-left group bg-white border border-slate-200 rounded-md p-7 card-hover focus:outline-none"
    >
      <div className="flex items-start justify-between">
        <div className="w-11 h-11 bg-[#0A1F44] text-white rounded-sm flex items-center justify-center group-hover:bg-[#1E40AF] transition-colors">
          <Icon className="w-5 h-5" />
        </div>
        <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-[#1E40AF] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
      </div>
      <h3 className="font-display text-xl md:text-2xl text-[#0A1F44] mt-6 tracking-tight">
        {service.title}
      </h3>
      <p className="text-sm text-slate-600 mt-3 leading-relaxed">{service.short}</p>
    </motion.button>
  );
}
